import * as $ from 'jquery';
import { ToastrService } from 'ngx-toastr';
import { Component, OnInit, HostListener, ViewChild, AfterViewInit, OnDestroy } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatDialog } from '@angular/material/dialog';

import { DialogComponent } from '../../../../common/components/dialog/dialog.component';

import { BroadcastService } from './../../../../services/infrastructure/broadcaster.service';
import { ConfigService } from './../../../../services/infrastructure/config.service';
import { CppService } from './../../../../services/cpp/cpp.service';
import { LoaderService } from './../../../../services/infrastructure/loader.service';
import { Subscription } from 'rxjs';
import { CPPFilterComponent } from '../../cpp-common-components/cpp-filter/cpp-filter.component';
import { LolLoggerService } from '../../../../common/shared/lol-logger.service';
import { CommonService } from '../../../../services/common/common.service';
import { MasterConstants } from '../../../../common/constants/master-constants';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { CppSraAddProductSliderModelService } from './cpp-sra-add-product-slider-model.service';
import { SraOrdersService } from '../../../../services/cpp/sra-orders.service';

@Component({
  selector: 'app-cpp-sra-add-product',
  templateUrl: './cpp-sra-add-product.component.html',
  styleUrls: ['./cpp-sra-add-product.component.scss']
})

export class CppSraAddProductComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild(CPPFilterComponent) cPPFilter: CPPFilterComponent;

  private subscription = new Array<Subscription>();

  productList: any;
  productAllDataSource: any;
  favProductDataSource: any;
  expandedElement: any | null; // internal
  isProductNotAdded = true;
  selectedProductList = new Array();
  itemList = new Array();
  plAccess = false;
  disclaimerMessage: string;
  selectedItem = 'UP';
  toggle = false;
  ToggleData = 'UP';
  order = false;
  isSortingEnable = false;
  selectedTabIndex = 0;
  displayedColumns: string[] = ['checkbox', 'product', 'flashmsg', 'detail', 'packageSize'];
  filterTypeList = [
    { label: 'Product Name', column: 'productName' },
    { label: 'Item Number', column: 'itemNumber' },
    { label: 'Active Ingredient', column: 'activeIngredients' },
    { label: 'Product Category', column: 'productCategory' },
    { label: 'GTIN', column: 'gtin' },
    { label: 'Package Size', column: 'packageSize' },
    { label: 'Vendor', column: 'vendor' },
    { label: 'Product Line', column: 'productLine' },

  ];

  constructor(
    public broadcastService: BroadcastService,
    public configService: ConfigService,
    private toastrService: ToastrService,
    private matDialog: MatDialog,
    private cppAddProductSliderModelService: CppSraAddProductSliderModelService,
    private loaderService: LoaderService,
    private sraOrdersService: SraOrdersService,
    private commonService: CommonService) {
  }

  // ngOnInit
  ngOnInit() {
    this.disclaimerMessage = 'Prices subject to change without notice. All Products(except inoculants) priced date of shipment & prices refresh daily';
    this.plAccess = this.commonService.checkUserRoleAccessTypeForMenu(null, MasterConstants.FUNCTION_CODE.CROP_PROTECTION_PRODUCT_PRICE_LIST);
  }

  // Selected product will add on order
  addSelectedProductToOrder() {
    if (this.selectedProductList.length > 0) {
      this.setAddProductToOrderAnalytics();
      this.broadcastService.broadcast(this.configService.DATA_CHANGE, { productCount: this.selectedProductList.length });
      this.toastrService.info('Product Added');
    }
    const data = Object.assign({}, this);
    this.cppAddProductSliderModelService.setData<CppSraAddProductComponent>(data);
    this.cppAddProductSliderModelService.CppSraClose();
  }

  // Enable or disable Add product to order btn based on item selection
  enableDisableAddProductBtn() {
    if (this.selectedProductList.length > 0) {
      this.isProductNotAdded = false;
    }
    else {
      this.isProductNotAdded = true;
    }
  }

  // Add or remove Favorite item for user
  addRemoveFavoriteItem(element) {
    const isFavorite = element.isFavorite;
    if (element.isFavorite) {
      element.isFavorite = false;
    }
    else {
      element.isFavorite = true;
    }

    this.loaderService.setLoaderStatus(true);
    this.subscription.push(this.sraOrdersService.saveProductForfavorite(element.itemId, isFavorite).subscribe((result: any) => {
      element.isFavorite = result.item1;
      if (result.item2 == 1) {
        const dialog = this.matDialog.open(DialogComponent, {
          data: {
            title: 'Maximum limit for favorite items has been reached.', content: ''
          }
        });
        dialog.addPanelClass('max-limit-pop');
      } else {
        const filters: any = {};
        filters.showFavoriteOnly = true;
        this.favProductDataSource = new MatTableDataSource(this.productList.filter(x => x.isFavorite == true));
      }
      this.loaderService.setLoaderStatus(false);
    }));
  }

  // Show or Hide Product detail
  showProductDetails(item) {
    item.isSelected = !item.isSelected;
  }

  // Get all product based on filter
  getAllProducts(filters) {
    filters.shipToOrDeliverToAccount = this.cppAddProductSliderModelService.shipToOrDeliverToAccount;
    filters.shipToAccountNumber = this.cppAddProductSliderModelService.shipToAccountNumber;
    this.loaderService.setLoaderStatus(true);
    this.subscription.push(this.sraOrdersService.getAllCppSroItemList(filters).subscribe((result: any) => {
      if (result && result.length > 0) {
        this.productList = result;
        this.productList.forEach(x => x.defaultDelDate = x.desiredDelDate);
      }
      else {
        if (!filters.showFavoriteOnly) {
          this.toastrService.info('No records found.');
        }
        this.productList = [];
      }

      this.productList.forEach(x => {
        if (this.selectedProductList.filter(y => y.itemNumber == x.itemNumber).length > 0) {
          x.IsProductSelected = true;
        }
        else {
          x.IsProductSelected = false;
        }
      });
      if (filters.showFavoriteOnly) {
        this.favProductDataSource = new MatTableDataSource(this.productList);
      } else {
        this.favProductDataSource = new MatTableDataSource(this.productList.filter(x => x.isFavorite == true));
        this.productAllDataSource = new MatTableDataSource(this.productList);
      }

      // set analytics for search
      this.setSearchAnalytics(filters);

      this.enableDisableSorting();
      this.loaderService.setLoaderStatus(false);
    }, (error) => {
      this.productList = [];
      this.productAllDataSource = new MatTableDataSource([]);
      let errorMsg = 'No records found.'
      this.toastrService.error(errorMsg);
      this.setErrorAnalytics(errorMsg);
      LolLoggerService.error(error);
      this.loaderService.setLoaderStatus(false);
    }));
  }

  setSearchAnalytics(filterData) {
    if (filterData.activeIngredient != null
      || filterData.gtin != null
      || filterData.itemNo != null
      || filterData.packageSize != null
      || filterData.productCategoryDescription != null
      || filterData.productLineDescription != null
      || filterData.productName != null
      || filterData.vendor != null) {
      var filters = [];
      if (filterData.productName != null) {
        filters.push({ 'type': 'Product Name', 'value': filterData.productName });
      }
      if (filterData.itemNo != null) {
        filters.push({ 'type': 'Item Number', 'value': filterData.itemNo.replace(/, /g, "|") });
      }
      if (filterData.activeIngredient != null) {
        filters.push({ 'type': 'Active Ingredient', 'value': filterData.activeIngredient.replace(/; /g, "|") });
      }
      if (filterData.productCategoryDescription != null) {
        filters.push({ 'type': 'Product Category', 'value': filterData.productCategoryDescription.replace(/, /g, "|") });
      }
      if (filterData.gtin != null) {
        filters.push({ 'type': 'GTIN', 'value': filterData.gtin });
      }
      if (filterData.packageSize != null) {
        filters.push({ 'type': 'Package Size', 'value': filterData.packageSize });
      }
      if (filterData.vendor != null) {
        filters.push({ 'type': 'Vendor', 'value': filterData.vendor.replace(/, /g, "|") });
      }
      if (filterData.productLineDescription != null) {
        filters.push({ 'type': 'Product Line', 'value': filterData.productLineDescription.replace(/, /g, "|") });
      }

      var eventData = {
        'event': 'search',
        'search': {
          'filters': filters,
          'keywords': '',
          'numberOfResults': this.productList.length,
          'searchType': 'products'
        },
        'shipToAccountID': this.cppAddProductSliderModelService.shipToAccountNumber,
        'soldToAccountID': this.cppAddProductSliderModelService.soldToAccountNumber
      };

      this.commonService.setDataLayerAnalytics(eventData);
    }
  }

  setAddProductToOrderAnalytics() {
    var eventData = {
      'event': 'Add Product to Order'
    };

    this.commonService.setDataLayerAnalytics(eventData);
  }

  setErrorAnalytics(errorMsg) {
    var eventData = {
      'event': 'form_error',
      'formName': 'Evolve – Crop Protection Order',
      'errorMessage': errorMsg
    };

    this.commonService.setDataLayerAnalytics(eventData);
  }

  // Add or remove product from selected list
  selectProduct(element): void {
    element.IsProductSelected = !element.IsProductSelected;
    this.keepRecords(element);
  }

  // Filter Product GridData based on filter values
  filterProductGridData(filters) {
    if (filters.clearAll == false) {
      this.setAddProdTableHeight();
      if (!this.validateProductFilter(filters)) {
        let errorMsg = 'Value must greater than equal to 2 characters.';
        this.toastrService.error(errorMsg);
        this.setErrorAnalytics(errorMsg);
        return true;
      }
      this.getAllProducts(filters);
    }
    else {
      this.productList = [];
      this.productAllDataSource = new MatTableDataSource(this.productList);
      filters.clearAll = false;

      const filter: any = {};
      filter.showFavoriteOnly = true;
      this.setAddProdTableHeight();
      this.getAllProducts(filter);
    }
    this.enableDisableAddProductBtn();
  }

  // Clear Grid data
  clearGridData(filters) {
    this.productList = [];
    this.productAllDataSource = new MatTableDataSource(this.productList);
  }

  // Update selected prodcut list
  keepRecords(product) {
    const itemNumber = product.itemNumber;
    if (product.IsProductSelected) {
      this.itemList.push(itemNumber);
      const item = this.productList.filter(i => i.itemNumber == itemNumber);
      const duplicateData = this.selectedProductList.find(y => y.itemNumber == product.itemNumber);
      if (duplicateData == undefined) {
        this.selectedProductList.push(item[0]);
      }
    }
    else {
      const index = this.itemList.indexOf(itemNumber);    // <-- Not supported in <IE9
      if (index !== -1) {
        this.itemList.splice(index, 1);
      }
      this.selectedProductList = this.selectedProductList.filter(i => i.itemNumber != itemNumber);
    }
    this.enableDisableAddProductBtn();
  }

  onTabChange(tabChangeEvent: MatTabChangeEvent) {
    this.selectedTabIndex = tabChangeEvent.index;
    this.cPPFilter.removeAllFilter();
    const filters: any = {};
    filters.showFavoriteOnly = true;
    this.setAddProdTableHeight();
    this.setfavProdTableHeight();
    this.getAllProducts(filters);
  }

  // set Add product table height
  setAddProdTableHeight() {
    const tableHeight = window.innerHeight - $('h3').outerHeight() - $('.form-sec ').outerHeight() - $('.mat-mdc-tab-header').outerHeight() - $('.add-order-sec').outerHeight() - 135;
    $('.prepayLandingTab .prodTableContainer').css('max-height', tableHeight + 'px');
  }
  setfavProdTableHeight() {
    const tableHeight = window.innerHeight - $('h3').outerHeight() - $('.form-sec ').outerHeight() - $('.mat-mdc-tab-header').outerHeight() - $('.add-order-sec').outerHeight() - 120;
    $('.prepayLandingTab .favProdTableContainer').css('max-height', tableHeight + 'px');
  }

  // Added Window onresize
  @HostListener('window:resize', ['$event']) onresize(event) {
    this.setAddProdTableHeight();
    this.setfavProdTableHeight();
  }

  // Added ngAfterViewInit to calculate height after view loading
  ngAfterViewInit() {
    // Set Dynamic Height of Panels
    this.setAddProdTableHeight();
    this.setfavProdTableHeight();
  }

  // ngOnDestroy
  ngOnDestroy() {
    this.subscription.forEach(subscription => subscription.unsubscribe());
  }

  sortData(Data: string) {
    this.toggle = !this.toggle;

    if (this.ToggleData != Data) {
      this.toggle = false;
      this.order = false;
      this.ToggleData = Data;
    }
    this.selectedItem = Data;
    this.order = !this.order;
    switch (Data) {
      case 'UP':
        {
          if (this.selectedTabIndex == 0) {
            var allDataSource = this.productAllDataSource.data;
            allDataSource.sort((n1, n2) => (this.order) ? n1.yourPrice - n2.yourPrice : n2.yourPrice - n1.yourPrice);
            this.productAllDataSource = new MatTableDataSource(allDataSource);
          }
          else {
            var favDataSource = this.favProductDataSource.data;
            favDataSource.sort((n1, n2) => (this.order) ? n1.yourPrice - n2.yourPrice : n2.yourPrice - n1.yourPrice);
            this.favProductDataSource = new MatTableDataSource(favDataSource);
          }
          break;
        }
    }
  }

  enableDisableSorting() {
    if (this.selectedTabIndex == 0) {
      if (this.productAllDataSource && this.productAllDataSource.data && this.productAllDataSource.data.length > 0) {
        this.isSortingEnable = true;
      }
      else {
        this.isSortingEnable = false;
      }
    }
    else {
      if (this.favProductDataSource && this.favProductDataSource.data && this.favProductDataSource.data.length > 0) {
        this.isSortingEnable = true;
      }
      else {
        this.isSortingEnable = false;
      }
    }
  }

  // to validate product filter
  validateProductFilter(productFilter) {
    let isValid = false;

    // To Validate MarketingBrand
    if (productFilter.itemNo != null && productFilter.itemNo.length > 0) {
      isValid = true;
    }

    // To Validate ProductName
    if (productFilter.productName !== null && productFilter.productName !== '' && productFilter.productName.toString().trim().length >= 2) {
      isValid = true;
    }

    // To Validate ActiveIngredient
    if (productFilter.activeIngredient !== null && productFilter.activeIngredient !== '' && productFilter.activeIngredient.toString().trim().length >= 2) {
      isValid = true;
    }

    // To Validate Vendor
    if (productFilter.vendor !== null && productFilter.vendor !== '' && productFilter.vendor.toString().trim().length >= 2) {
      isValid = true;
    }

    // To Validate Gtin
    if (productFilter.gtin !== null && productFilter.gtin !== '' && productFilter.gtin.toString().trim().length >= 2) {
      isValid = true;
    }
    // To Validate ProductLine
    if (productFilter.productLine !== null && productFilter.productLine !== '' && productFilter.productLine.toString().trim().length >= 2) {
      isValid = true;
    }

    // To Validate PackageSize
    if (productFilter.packageSize !== null && productFilter.packageSize !== '' && productFilter.packageSize.toString().trim().length >= 2) {
      isValid = true;
    }

    // To Validate ProductLine
    if (productFilter.productCategory !== null && productFilter.productCategory !== '' && productFilter.productCategory.toString().trim().length >= 2) {
      isValid = true;
    }

    if (productFilter.productName == null
      && (productFilter.itemNo == null || productFilter.itemNo.length <= 0)
      && productFilter.activeIngredient == null
      && productFilter.vendor == null
      && productFilter.gtin == null
      && productFilter.productLine == null
      && productFilter.packageSize == null
      && productFilter.productCategory == null) {
      isValid = false;
    }
    return isValid;
  }
}
